import { initializeCommonPageScripts } from './inc/cco-common.js'
import { initializeNavbar } from './inc/cco-navbar.js'
import { initializeNetworkMapBox } from './inc/cco-network-map.js'
import {  initializeCareAlgorithmsGallery, 
          initializeRedFlagsGallery, 
          initializeActiveProjectsGallery,
          initializeNetworkUpdatesGallery,
          initializeMediaItemsGallery,
          initializeStoryGallery } from './inc/cco-swiper.js'
import { initializePageNavigation } from './inc/cco-page-navigation.js'
import { initializePageAnimations } from './inc/cco-animations.js'
import { initializeParallax } from './inc/cco-parallax.js'

const pageReady = () => {
  initializeCommonPageScripts()
  initializeNavbar()
  initializeParallax()
  initializePageAnimations()
  
  // Home Page
  if (document.body.classList.contains('page-home')) {
    initializeNetworkMapBox()
  }

  // Education - Care Providers Page
  if (document.body.classList.contains('page-education-care-providers')) {
    initializePageNavigation()
    initializeCareAlgorithmsGallery()
    initializeRedFlagsGallery()
  }

  // Research Page
  if (document.body.classList.contains('page-research')) {
    initializeActiveProjectsGallery()
  }

  // News & Updates Page
  if (document.body.classList.contains('page-news-updates')) {
    initializeNetworkUpdatesGallery()
    initializeMediaItemsGallery()
  }

  // Stories Driver
  if (document.querySelector('.main-content > section.stories')) {
    initializeStoryGallery()
  }
}

if (
  document.readyState === 'complete'
  || (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  pageReady()
} else {
  document.addEventListener('DOMContentLoaded', pageReady)
}
